import BuilderLayout from "../../Builder/BuilderLayout/BuilderLayout";
import BuilderTitle from "../../Builder/BuilderLayout/BuilderTitle";
import {
  CommonBuilderComponent,
  DeleteBuilderButton,
} from "../../Builder/Common/CommonBuilderComponent";
import ForumDetails from "./ForumDetails";
import Associated from "./Associated";
import AddContent from "./AddContent";
import { useEffect, useRef, useState } from "react";
import { setPage, setReset } from "../../../../../slices/adminPageSlice";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SelectionSidePanel from "../../Builder/SelectionPanel/SelectionSidePanel";
import DocumentList from "../../Builder/BuilderCard/DocumentList";
import ViewSummary from "../../../../ViewSummary/ViewSummary";
import { useSelector } from "react-redux";
import ModalForumDetailPage from "../../Builder/PreviewModal/ModalForumDetailPage";
import {
  resetAssociatedContent,
  setAssociatedContent,
} from "../../../../../slices/forumBuilderSlice";
import { transformAssociatedItems } from "./ForumCommon";
import {
  getDisclaimerDetailsFromId,
  uploadThumbnailAndGiveFileId,
} from "../../../../../utils/function";
import { deleteAPI, postAPI } from "../../../../../API/ApiService";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../../utils/Toast/toast";
import { BASE_URL } from "../../../../../constant/apiUrl";
import DeleteModal from "../../Builder/DeleteModal/DeleteModal";
import FritoForumDetailPage from "../../../../FritoForumPage/FritoForumDetailPage";

const CreateForumLayout = () => {
  const [openModal, setOpenModal] = useState(false);
  const [forumModal, setForumModal] = useState(false);
  const [payloadData, setPayloadData] = useState({});
  const [forumData, setForumData] = useState(false);
  const [type, setType] = useState(null);
  const [status, setStatus] = useState(null);
  const { id } = useParams();
  const { disclaimers } = useSelector((state) => state.internalFilter);
  const { flagUser } = useSelector((store) => store.user);
  const [isPublishing, setIsPublishing] = useState(false);
  const { viewSummaryDrawer } = useSelector((store) => store.viewSummary);
  const [thumbnailId, setThumbnailId] = useState(null);
  const [autoPopulate, setAutoPopulate] = useState(null);
  const [deniedModal, setDeniedModal] = useState(false);
  const [deleteLoad, setDeleteLoad] = useState(false);

  const { associatedDocuments, associatedLinks, associatedVideos } =
    useSelector((state) => state.forumBuilder);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      dispatch(resetAssociatedContent());
    }
  }, [id]);

  const handleBack = () => {
    navigate("/admin");
    dispatch(setPage("Forum builder"));
    dispatch(setReset(false));
  };

  const handleOpen = (label) => {
    setType(label);
    setOpenModal(true);
  };

  const PreviewModal = (data) => {
    setPayloadData({ ...data, status });

    const newData = {
      ...data,
      cdnUrl: data?.selectedImage[0]?.preview,
      keywords: data.keywords
        ?.split(",")
        .map((k) => k.trim())
        .filter(Boolean),
      status,
      videos: transformAssociatedItems(associatedVideos),
      documents: transformAssociatedItems(associatedDocuments),
      links: transformAssociatedItems(associatedLinks),
      languages: data.languageId?.displayText
        ? [data.languageId.displayText]
        : [],
      sectors: data?.sectorId?.map((item) => item.displayText),
      countries: data?.countryId?.map((item) => item.displayText),
      disclaimerText: getDisclaimerDetailsFromId(
        data.disclaimerId.id,
        disclaimers
      ),
      views: autoPopulate?.views ? autoPopulate?.views : 0,
      likes: autoPopulate?.likes ? autoPopulate?.likes : 0,
      subjects: data.subjectId.map((item) => item.displayText),
      postedDate: autoPopulate?.postedDate
        ? autoPopulate?.postedDate
        : new Date(),
      postedBy: autoPopulate?.postedBy ? autoPopulate?.postedBy : flagUser.name,
    };

    setForumData(newData);
    setForumModal(true);
  };
  const getFlagConfig = (type) => {
    return {
      documentFlag: type === "document" || type === "all",
      videoFlag: type === "video" || type === "all",
      linkFlag: type === "link" || type === "all",
    };
  };

  const handlePublish = async () => {
    try {
      setIsPublishing(true);

      let thumbnailFileId = thumbnailId; // keep old one by default
      if (payloadData?.selectedImage) {
        // Case 1: User picked a new File
        if (payloadData.selectedImage[0] instanceof File) {
          const uploadResponse = await uploadThumbnailAndGiveFileId(
            payloadData.selectedImage
          );
          thumbnailFileId = uploadResponse[0];
        }
      }

      const finalData = {
        title: payloadData.title,
        description: payloadData.description || " ",
        details: {
          languageId: payloadData?.languageId?.id,
          disclaimerId: payloadData?.disclaimerId?.id,
          keywords: payloadData.keywords
            ?.split(",")
            .map((k) => k.trim())
            .filter(Boolean),
          sectorId: payloadData?.sectorId?.map((item) => item.id),
          subjectId: payloadData.subjectId.map((item) => item.id),
          countryId: payloadData.countryId.map((item) => item.id),
        },
        thumbnailFileId: thumbnailFileId,
        status: payloadData.status != null ? payloadData.status : false,
        associatedContent: {
          videos: associatedVideos.map((item) => item.contentId),
          documents: associatedDocuments.map((item) => item.contentId),
          links: associatedLinks.map((item) => item.contentId),
        },
      };

      let finlPayload = {};
      if (id) {
        finlPayload = { ...finalData, id: Number(id) };
      } else {
        finlPayload = { ...finalData };
      }
      const response = await postAPI(
        `${BASE_URL}/forum/create-forum`,
        finlPayload
      );

      if (response?.status === 200) {
        if (payloadData.status != null) {
          if (payloadData.status === true) {
            showSuccessToast("Forum published successfully!");
          } else {
            showSuccessToast("Forum saved successfully!");
          }
        }

        setForumModal(false);
        handleBack();
      } else {
        showErrorToast(
          response.message || "Failed to publish forum. Please try again."
        );
        console.error("Failed to publish forum:", response.message);
      }
    } catch (error) {
      showErrorToast(
        "An error occurred while publishing the forum. Please try again."
      );
      console.error("Error publishing forum:", error);
    } finally {
      setIsPublishing(false);
    }
  };

  const handleDelete = async () => {
    try {
      setDeleteLoad(true);
      const data = await deleteAPI(`${BASE_URL}/forum/delete/${id}`);
      if (data?.status === 200) {
        showSuccessToast("Forum Deleted Successfully");
        handleBack();
      }
    } catch (e) {
      showErrorToast("Failed To Delete Forum");
    } finally {
      setDeleteLoad(false);
    }
  };
  return (
    <BuilderLayout
      label={id ? "Save forum" : "Create forum"}
      form="forum-form"
      backlabel="Back to forum list"
      back={handleBack}
    >
      {viewSummaryDrawer && <ViewSummary />}

      {deniedModal && (
        <DeleteModal
          title={"Delete Forum"}
          setClose={() => setDeniedModal(false)}
          open={deniedModal}
          handleDelete={handleDelete}
          text={"After an Forum is Removed, you can't undo it. Are you sure?"}
          loading={deleteLoad}
        />
      )}

      {forumModal && (
        <ModalForumDetailPage
          forumModal={forumModal}
          setForumModal={setForumModal}
          forumData={forumData}
          handlePublish={handlePublish}
          isPublishing={isPublishing}
          status={status}
          text={`${status ? "Publish Forum" : "Save Forum"}`}
        >
          <FritoForumDetailPage
            previewData={forumData}
            showBackButton={false}
            enabled={false}
            cardButtonDisable={true}
            forumId={true}
          />
        </ModalForumDetailPage>
      )}

      <SelectionSidePanel
        open={openModal}
        setOpen={setOpenModal}
        selectedItems={{
          document: associatedDocuments,
          video: associatedVideos,
          link: associatedLinks,
        }}
        handleRowSelection={(type, rows) => {
          dispatch(setAssociatedContent({ contentType: type, data: rows }));
        }}
        key={type}
        type={type} // Pass this too, if needed
        flagConfig={getFlagConfig(type)}
      />

      <div className="flex flex-col gap-4">
        <CommonBuilderComponent>
          <div className="flex flex-col gap-4 w-full">
            <BuilderTitle
              title="Forum details"
              rightElement={
                id && (
                  <DeleteBuilderButton
                    label={"Delete forum"}
                    onClick={() => {
                      setDeniedModal(true);
                    }}
                  />
                )
              }
            />
            <ForumDetails
              PreviewModal={PreviewModal}
              setStatus={setStatus}
              status={status}
              setThumbnailId={setThumbnailId}
              setAutoPopulate={setAutoPopulate}
            />
          </div>
        </CommonBuilderComponent>

        <Associated title="Associated content" />
        <CommonBuilderComponent>
          <AddContent label="Videos" onClick={() => handleOpen("video")} />
          <DocumentList data={associatedVideos} type="video" />
        </CommonBuilderComponent>
        <CommonBuilderComponent>
          <AddContent
            label="Documents"
            onClick={() => handleOpen("document")}
          />
          <DocumentList
            data={associatedDocuments}
            label={"Documents"}
            type="document"
          />
        </CommonBuilderComponent>
        <CommonBuilderComponent>
          <AddContent label="Links" onClick={() => handleOpen("link")} />
          <DocumentList data={associatedLinks} label={"Links"} type="link" />
        </CommonBuilderComponent>
      </div>
    </BuilderLayout>
  );
};

export default CreateForumLayout;
